import Results from './Results.jsx';

export default Results;
